/**
 * Copyright (C) Sitevision AB 2002-2026, all rights reserved
 */
const updatePage = (select, parameter, url) => {
  if (!select || select.selectedIndex < 0) {
    return;
  }
  const value = select.options[select.selectedIndex].value;
  try {
    const u = new URL(url, window.location.href);
    u.searchParams.set(parameter, value);
    window.location.href = u.toString();
  } catch {
    const base = String(url || '');
    const separator = base.indexOf('?') === -1 ? '?' : '&';
    window.location.href =
      base +
      separator +
      encodeURIComponent(parameter) +
      '=' +
      encodeURIComponent(value);
  }
};

const selects = document.querySelectorAll('[data-sv-select-action-url]');
for (const select of selects) {
  select.addEventListener('change', (e) => {
    const el = e.currentTarget;
    const url =
      el.getAttribute('data-sv-select-action-url') ||
      el.dataset.svSelectActionUrl ||
      '';
    const name = el.getAttribute('name');
    updatePage(el, name, url);
  });
}
